import React, { useState, useEffect } from 'react';
import cx from 'classnames';
import { CheckOutlined } from '@ant-design/icons';
import moment from 'moment';
import styles from '../styles.module.less';

export type TCouponItem = {
  coupon_id: number;
  coupon_purpose: any;
  coupon_log_id: number;
  coupon_value: number;
  coupon_name: string;
  etime: number;
};

export type SuitableCouponItem = {
  coupon_log_id: number;
  coupon_value: number;
};

type TCouponItemCom = {
  item: TCouponItem;
  onChange: () => void;
  activeId?: number;
  suitableCouponId?: number;
};

const CouponItem: React.FC<TCouponItemCom> = ({
  activeId,
  item,
  onChange,
  suitableCouponId,
}) => {
  const [isActive, setIsActive] = useState(false);
  const [isAutoClick, setIsAutoClick] = useState(true);
  useEffect(() => {
    setIsActive(activeId === item.coupon_log_id);
    console.log('item', item);
    console.log('suitableCouponId', suitableCouponId);
    if (isAutoClick && suitableCouponId === item.coupon_log_id) {
      setIsAutoClick(false);
      let clickItem = document.getElementById(
        'couponItem_div_' + suitableCouponId,
      );
      if (clickItem) {
        clickItem.click();
        console.log('自动勾选了优惠券', suitableCouponId);
      }
    }
  }, [activeId, isAutoClick]);

  return (
    <div
      id={'couponItem_div_' + item.coupon_log_id}
      className={cx(styles.coupon_item, isActive && styles.active)}
      onClick={() => {
        setIsActive(!isActive);
        onChange();
      }}
    >
      <div className={styles.coupon_item_body}>
        <p className={styles.price_text}>￥{item.coupon_value}</p>
        <p className={styles.time_text}>适用于：{item.coupon_name}</p>
        <div className={styles.checkbox}>
          <CheckOutlined />
        </div>
      </div>
      <div className={styles.coupon_item_footer}>
        有效期至：{moment(item.etime).format('YYYY-MM-DD')}
      </div>
    </div>
  );
};
export default CouponItem;
